import { Intercom } from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';
import type { PropsWithChildren } from 'react';

import { getUserDisplayName, getUserEmail, getUserId, keycloak } from '@/lib/auth';
import { useAuth } from '@/providers/useAuth';

const intercomAppId = import.meta.env.VITE_INTERCOM_APP_ID?.trim();

export function IntercomProvider({ children }: PropsWithChildren) {
    const { isReady, isAuthenticated, token } = useAuth();

    useEffect(() => {
        if (!intercomAppId || !isReady || !isAuthenticated || !token) {
            return;
        }

        const userId = getUserId();

        if (!userId) {
            return;
        }

        const createdAt = keycloak.tokenParsed?.iat;

        Intercom({
            app_id: intercomAppId,
            user_id: userId,
            name: getUserDisplayName(),
            email: getUserEmail() ?? undefined,
            created_at: typeof createdAt === 'number' ? createdAt : undefined
        });
    }, [isAuthenticated, isReady, token]);

    return children;
}
